import type { PageMeta } from "./envelope";

/**
 * Следующий курсор для `useInfiniteQuery`.
 *
 * Условий два, и оба обязательны:
 *  - `meta` в контракте опциональна — её отсутствие означает «страниц больше
 *    нет», а не «читай дальше без курсора»;
 *  - `next_cursor` типизирован как `string | null`, и при `has_more: true`
 *    с пустым курсором цикл догрузки не остановился бы никогда.
 *
 * Останов именно по `has_more`, а не по пустой странице: пустая страница при
 * `has_more: true` — законный ответ, если все записи страницы отфильтрованы.
 */
export function nextCursor(meta: PageMeta | undefined): string | undefined {
  if (!meta?.has_more) return undefined;
  return meta.next_cursor ?? undefined;
}

/** Умолчание бэкенда — 20, максимум 100 (сверх — 422). */
export const PAGE_LIMIT = 20;
